import axios from "axios";
import { envVariables } from "../config/global.config";
import { axiosGet, axiosPatch, axiosPost } from "./api.gateway";

export const doLogin = async (email, password) => {
  try {
    const response = await axios.post(`${envVariables.API_URL}/api/auth/login`, { email, password });
    if (!response) {
      throw new Error('An error occurred');
    }
    if(response.data.success === false){
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLoginUser = async () => {
  try {
    const response = await axiosGet('/auth/user');
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchGeoStates = async () => {
  try {
    const response = await axiosGet(`/auth/geo/states`);
    return response;
  } catch (error) {
    throw error;
  }
}

export const changePassword = async (email, newPassword, otp) => {
  try {
    const response = await axiosPatch(`/auth/reset-password`, { email, newPassword, otp });
    return response;
  } catch (error) {
    throw error;
  }
};
export const accountActivate = async (email, otp) => {
  try {
    const response = await axiosPost(`/auth/activate`, { email, otp });
    return response;
  } catch (error) {
    throw error;
  }
};

export const sendOTP = async (email) => {
  try {
    const response = await axiosPost(`/auth/send-otp`, { email });
    return response;
  } catch (error) {
    throw error;
  }
};